<template>
    <div class="home">
        <div class="container">
            <swiper :options="bannerSwiperOption" ref="bannerSwiper" class="bannerSwiper"
                    v-if="mobileArr.length > 0">
                <swiper-slide v-for="(item,index) in mobileArr" :key="index"><img :src="item" alt="">
                </swiper-slide>
            </swiper>
            <div class="scroll">
                <h2>{{$t('nav.theme')}}</h2>
                <div class="slide-box">
                    <swiper :options="themeParkSwiperOption" ref="themeParkSwiper" class="themeParkSwiper">
                        <swiper-slide class="slide1 slide" v-for="(img ,index) in canvasList" :key="index"><img
                                :src="img" alt="" @click="themeLink(index)"></swiper-slide>
                    </swiper>
                </div>
            </div>
            <div class="content">
                <div class="title" @click="news(titleContent.id)">
                    <div class="tit_content" ref="wrap"><p ref="titWidth" :class='animationClass' :style="contentStyle">
                        {{titleContent.title}}</p></div>
                </div>
                <ul class="server_icons">
                    <li v-for="(n,i) in minorArr" @click="workTime(i)"><i
                            :class="'icons'+(parseInt(i)+parseInt('1'))"></i><span>{{n.name}}</span></li>
                </ul>
                <ul class="reservation">
                    <li :class="{ticket:i=='0',card:i=='2',hotel:i=='1',restaurant:i=='3'}"
                        v-for="(ticketList,i) in mainLists">
                        <a :href='ticketList.mobile_value'><span :class="{lang_en_span:lang ==='en'}">{{ticketList.name}}</span></a>
                        <ul class="reservation_item_left">
                            <li @click="ticketLink(ticketItem.mobile_value)"
                                v-for="(ticketItem, index) in ticketList.child" :key="index">
                                {{ticketItem.name}}
                            </li>
                        </ul>
                    </li>
                </ul>
                <div class="activity">
                    <h2>{{$t('nav.activity')}}<span @click="goActivity()"></span></h2>
                    <div class="activity_scroll">
                        <div v-for="(a,i) in activityArr" :key="i" class="activity_box">
                            <div class="activity_scroll_item" @click="activityLink(a.id)">
                                <div class="activity_img">
                                    <img :src="weburl+a.image" alt="">
                                </div>
                                <h4>{{a.title}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="huge" @click="hideHuge" v-if="isHuge" @touchmove.prevent>
            <div class="huge_img" @click="hugeLink(huge_content.mobile_value)"><img :src="weburl+huge_content.img"
                                                                                    alt=""></div>
            <div class="del_img"><img src="../assets/images/index/del.png" alt=""></div>
        </div>
    </div>
</template>

<script>
    import img from '../assets/images/index/index_banner.png';

    export default {
        name: "home",
        inject: ['reload'],
        data: function () {
            return {
                canvasList: [],
                themeIndex: 0,
                minorArr: [],
                activityArr: [],
                titleContent: '',
                img: img,
                mainLists: '',
                classIndex: '',
                mobileArr: [],
                timer: '',
                moveList: {},
                themeParkSwiperOption: {
                    autoplay: true,
                    delay: 800,
                    disableOnInteraction: true,
                    autoplayDisableOnInteraction: false,
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                },
                bannerSwiperOption: {
                    autoplay: true,
                    delay: 800,
                    disableOnInteraction: true,
                    autoplayDisableOnInteraction: false,
                    loop: true
                },
                swiperTimer: "",
                speed: 0.02,//为了过渡，已经运动速度相等，我们用px/s，即每px需要多少秒，暂定每px需要0.02s
                duration: 0,
                animationClass: '',
                contentStyle: {},
                delay: 0,
                isHuge: true,
                huge_content: {},
                lang: this.$i18n.locale
            }
        },
        components: {
            // Swiper,
            // Slide
        },
        created: function () {
            this.getHomeInfo();
            this.getActivity();
            this.getNews();
            this.$store.commit('set_current', 0);
            this.$store.commit("set_title", 'name');
            // console.log(this.lang)
        },
        methods: {
            getHomeInfo() {
                //获取侧边栏，以及主题乐园
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/homelink/getTeletext",
                    dataType: "json",
                    data: {
                        lang: window.$lang
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            if (window.$lang === "1") {
                                for (let i in res.data.result.canvas) {
                                    this.canvasList.push(this.weburl + res.data.result.canvas[i].img); //属性
                                }
                            }
                            if (window.$lang === '2') {
                                this.canvasList = [
                                    require('../assets/images/lang/en/theme_01.png'),
                                    require('../assets/images/lang/en/theme_02.png'),
                                    require('../assets/images/lang/en/theme_03.png'),
                                    require('../assets/images/lang/en/theme_04.png'),
                                    require('../assets/images/lang/en/theme_05.png'),
                                    require('../assets/images/lang/en/theme_06.png'),
                                    require('../assets/images/lang/en/theme_07.png'),
                                ]
                            }
                            if (window.$lang === '3') {
                                this.canvasList = [
                                    require('../assets/images/lang/jap/theme_01.png'),
                                    require('../assets/images/lang/jap/theme_02.png'),
                                    require('../assets/images/lang/jap/theme_03.png'),
                                    require('../assets/images/lang/jap/theme_04.png'),
                                    require('../assets/images/lang/jap/theme_05.png'),
                                    require('../assets/images/lang/jap/theme_06.png'),
                                    require('../assets/images/lang/jap/theme_07.png'),
                                ]
                            }
                            if (window.$lang === '4') {
                                this.canvasList = [
                                    require('../assets/images/lang/kor/theme_01.png'),
                                    require('../assets/images/lang/kor/theme_02.png'),
                                    require('../assets/images/lang/kor/theme_03.png'),
                                    require('../assets/images/lang/kor/theme_04.png'),
                                    require('../assets/images/lang/kor/theme_05.png'),
                                    require('../assets/images/lang/kor/theme_06.png'),
                                    require('../assets/images/lang/kor/theme_07.png'),
                                ]
                            }

                            if (!res.data.result.mobile) {
                                this.mobileArr.push(this.img);
                            } else {
                                for (let i in res.data.result.mobile) {
                                    this.mobileArr.push(this.weburl + res.data.result.mobile[i].img); //属性
                                }
                            }
                            if (res.data.result.mobile_huge.img) {
                                this.huge_content = res.data.result.mobile_huge;
                            } else {
                                this.isHuge = false;
                            }
                            this.mainLists = res.data.result.content.main;
                            for (let min in res.data.result.content.minor) {
                                let obj = {};
                                obj.name = res.data.result.content.minor[min].name;
                                this.minorArr.push(obj);
                            }
                            /*if (this.$i18n.locale !== 'zh') {
                                this.mainLists = this.$t('home_axios.main');
                                this.minorArr = this.$t('home_axios.minor');
                            }
                            else {
                                this.mainLists = res.data.result.content.main;
                                for (let min in res.data.result.content.minor) {
                                    let obj = {};
                                    obj.name = res.data.result.content.minor[min].name;
                                    this.minorArr.push(obj);
                                }
                            }*/
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            getActivity() {
                //获取活动部分
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + "/home/index/getInformation",
                    dataType: "json",
                    data: {
                        lang: window.$lang
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            this.activityArr = res.data.result;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            getNews() {
                //获取新闻
                this.$http({
                    method: "post",
                    url: this.weburl + "/home/index/getNews",
                    dataType: "json",
                    data: {
                        lang: window.$lang
                    }
                })
                    .then(res => {
                        if (res.data.status === 1) {
                            this.titleContent = res.data.result;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            themeLink(i) {
                this.$store.commit('set_current', '1');
                this.reload();
                switch (i) {
                    case 0:
                        this.$router.push({path: '/themeScream'});
                        this.$store.commit('set_park_index', '0');
                        break;
                    case 1:
                        this.$router.push({path: '/themePark'});
                        this.$store.commit('set_park_index', "1");
                        break;
                    case 2:
                        this.$router.push({path: '/themeHoliday'});
                        this.$store.commit('set_park_index', '2');
                        break;
                    case 3:
                        this.$router.push({path: '/themeWetland'});
                        this.$store.commit('set_park_index', '6');
                        break;
                    case 4:
                        this.$router.push({path: '/themeFarmhouse'});
                        this.$store.commit('set_park_index', '4');
                        break;
                    case 5:
                        this.$router.push({path: '/themeMilitary'});
                        this.$store.commit('set_park_index', '3');
                        break;
                    case 6:
                        this.$router.push({path: '/themeSea'});
                        this.$store.commit('set_park_index', '5');
                        break;

                }
            },
            ticketLink(i) {
                window.location.href = i;
            },
            workTime(i) {
                this.$store.commit('set_current', '5');
                switch (i) {
                    case 0:
                        this.$router.push({path: '/workTime'});
                        this.$store.commit('set_current_index', '3');
                        break;
                    case 1:
                        this.$router.push({path: '/traffic'});
                        this.$store.commit('set_current_index', '0');
                        break;
                    case 2:
                        this.$router.push({path: '/parkMap'});
                        // this.$store.commit('set_current', '5');
                        // this.$store.commit('set_current_index', '2');
                        this.$store.commit('set_current_index', '1');
                        break;
                    case 3:
                        // this.$router.push({path: '/parkRoute'});
                        // this.$store.commit('set_current', '5');
                        this.$router.push({path: '/sale'});
                        this.$store.commit('set_current_index', '7');
                        break;
                }
            },
            goActivity() {
                this.$router.push({path: `/activity`,})
            },
            activityLink(id) {
                this.$store.commit('set_current', '3');
                this.$router.push({path: `/activityDetail/${id}`,})
            },
            news(id) {
                this.$router.push({
                    path: `/newsDetail/${id}`,
                })
            },
            hideHuge() {
                this.stopPropagation();
                this.isHuge = false;
            },
            hugeLink(id) {
                this.stopPropagation();
                window.location.href = id;

            },
            stopPropagation(e) {
                e = e || window.event;
                if (e.stopPropagation) { //W3C阻止冒泡方法
                    e.stopPropagation();
                } else {
                    e.cancelBubble = true; //IE阻止冒泡方法
                }
            },

        },
        mounted() {
            this.swiperTimer = setInterval(() => {
                if (!this.swiper.autoplay.running) {
                    this.swiper.autoplay.start();
                }
            }, 3000);
            this.$nextTick(() => {
                const that = this;
                setTimeout(() => {
                    const {wrap, titWidth} = that.$refs;
                    if (!wrap || !titWidth) {
                        return;
                    }
                    const wrapWidth = wrap.getBoundingClientRect().width;
                    const offsetWidth = titWidth.getBoundingClientRect().width;
                    this.delay = offsetWidth * that.speed * 1000;
                    if (offsetWidth > wrapWidth) {
                        that.animationClass = 'tit_content__play';
                        that.contentStyle = {
                            animationDelay: 0,//延时
                            animationDuration: offsetWidth * that.speed + 's',
                        };
                        setTimeout(() => {
                            this.animationClass = 'tit_content--infinite ';
                            this.contentStyle = {
                                animationDelay: 0,//延时
                                animationDuration: (wrapWidth + offsetWidth) * this.speed + 's',//总时间
                                paddingLeft: wrapWidth + 'px'
                            };
                        }, this.delay)
                    }
                }, 1000)


            })
        },
        destroyed: function () {
            clearInterval(this.swiperTimer);
            this.swiperTimer = "";
        },
        computed: {
            //计算属性，
            weburl: function () {
                return this.$store.state.weburl;
            },
            index_information: function () {
                //先用变量接住我们存储在vuex里面的数据，
                return this.$store.state.home.index_information;
            },
            current: function () {
                //头部六大块显示的位置
                return this.$store.state.home.current;
            },
            current_index: function () {
                return this.$store.state.service.current_index;
            },
            park_index() {
                //主題樂園的对应的页面 存储的数据
                return this.$store.state.park.park_index;
            },
            swiper() {
                return this.$refs.themeParkSwiper.swiper
            }
        },

    }

</script>
<style scoped lang="less">
    @import "../assets/less/common";

    .home {
        padding-bottom: 1px;
        background: tint(@bg, 50%);
        .scroll {
            width: @width;
            height: 172px;
            @media (max-width: 360px) {
                height: 162px;
            }
            @media (min-width: 411px) {
                height: 175px;
            }
            @media (max-width: 320px) {
                height: 150px;
            }
            .box-sizing;
            padding-left: 15px;
            .slide-item {

                width: 100px;
                height: 135px;
                .border-radius(10px);
                margin-right: 12px;
                img {
                    width: @width;
                    .border-radius(10px);
                }
            }
        }
        .scroll h2, .activity h2 {
            line-height: 40px;
            font-size: @font;

        }
        .slide-box, .activity_scroll {
            display: -webkit-box;
            overflow-x: scroll;
            overflow-y: hidden;
            -webkit-overflow-scrolling: touch;
        }
        .slide-box {
            height: 125px;

            @media (max-width: 360px) {
                height: 115px;
            }
            @media (min-width: 411px) {
                height: 135px;
            }
            @media (max-width: 320px) {
                height: 105px;
            }
        }
        /*隐藏滚动条*/
        .slide-box::-webkit-scrollbar {
            display: none;
        }
        .content {
            width: 90%;
            margin: 10px auto 0;
            .title {
                width: @width;
                height: 45px;
                background: url(../assets/images/index/news_1.png) no-repeat;
                background-size: 100%;
                .box-sizing;
                padding: 0 18%;
                @media (max-width: 360px) {
                    height: 37px;
                }
                @media (max-width: 411px) {
                    height: 50px;
                }
                .tit_content {
                    overflow: hidden;
                    width: @width;
                    height: @width;
                    line-height: 45px;
                    font-size: .9rem;
                    @media (max-width: 360px) {
                        line-height: 41px;
                    }
                    p {
                        white-space: nowrap;
                        word-wrap: normal;
                        display: inline-block;
                        color: #fef167;
                    }
                    &__play {
                        animation-name: van-notice-bar-play;
                        animation-iteration-count: 1;
                        animation-fill-mode: both;
                        animation-timing-function: linear;
                    }
                    &--infinite {
                        animation-name: van-notice-bar-play-infinite;
                        animation-iteration-count: infinite;
                        animation-fill-mode: both;
                        animation-timing-function: linear;
                    }
                }
            }
        }
        .server_icons {
            display: flex;
            justify-content: center;
            /*align-items: center;*/
            margin-top: 10px;
            width: @width;
            /*height: 74px;*/
            li {
                width: 22%;
                /*height: 74px;*/
                margin-right: 4%;
                font-size: @font - .1;
                text-align: center;
                i {
                    display: block;
                    width: 100%;
                    height: 50px;
                    &.icons1 {
                        background: url(../assets/images/index/index_1.png) no-repeat  9px -2px;;
                        background-size: 56px auto;
                        @media (max-width: 320px) {
                            background: url(../assets/images/index/index_1.png) no-repeat 10px 0;
                            background-size: 47px auto;
                        }
                    }
                    &.icons2 {
                        background: url(../assets/images/index/index_2.png) no-repeat 9px -2px;
                        background-size: 56px auto;
                        @media (max-width: 320px) {
                            background: url(../assets/images/index/index_2.png) no-repeat 10px 0;
                            background-size: 47px auto;
                        }
                    }
                    &.icons3 {
                        background: url(../assets/images/index/index_3.png) no-repeat 9px -2px;
                        background-size: 56px auto;
                        @media (max-width: 320px) {
                            background: url(../assets/images/index/index_3.png) no-repeat 10px 0;
                            background-size: 47px auto;
                        }
                    }
                    &.icons4 {
                        background: url(../assets/images/index/index_4.png) no-repeat 9px -2px;
                        background-size: 56px auto;
                        @media (max-width: 320px) {
                            background: url(../assets/images/index/index_4.png) no-repeat 10px 0;
                            background-size: 47px auto;
                        }
                    }
                }
                span {
                    line-height: 24px;
                }

                &:last-child {
                    margin-right: 0;
                }
            }

        }
        .activity_scroll::-webkit-scrollbar {
            display: none;
        }
        .activity {
            margin-bottom: 20px;
            .activity_scroll {
                height: 125px;
            }
            .activity_box {
                display: block;
                width: 46%;
                height: 115px;
                margin: 5px 15px 0 4px;
                &:last-child {
                    padding-right: 10px;
                }
            }
            .activity_scroll_item {
                width: 100%;
                height: 115px;
                background: @font-primary;
                .border-radius(10px);
                box-shadow: 1px 1px 8px 0 #b5a7a7;
                .activity_img {
                    width: @width;
                    height: 75%;
                    img {
                        .img;
                        .border-radius(10px 10px 0 0);
                    }

                }
                h4 {
                    color: #282828;
                    font-size: .9rem;
                    padding-left: 5%;
                    width: 85%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    @media (max-width: 414px) {
                        line-height: 26px;
                    }
                    @media (max-width: 378px) {
                        line-height: 28px;
                    }

                }

            }
            h2 {
                position: relative;
                span {
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: block;
                    width: 30px;
                    height: 30px;
                    background: url(../assets/images/personalCenter/direction.png) no-repeat 15px 12px;
                    background-size: 8px auto;

                }
            }

        }
    }

    .content_img {
        width: @width;

        img {
            width: @width;
        }
    }

    .reservation > li {
        margin-top: 10px;
        width: 100%;
        height: 110px;
        @media (max-width: 360px) {
            height: 100px;
        }
        & > a, & > ul {
            float: left;
            height: @width;
        }
        & > a {
            width: 32%;
            span {
                float: right;
                font-size: @font + .7;
                color: @font-primary;
                width: 61%;
                height: 50%;
                margin: 8px 2px;
                letter-spacing: 5px;
                line-height: 30px;
                text-shadow: 0 1px 1.5px rgba(0, 0, 0, 0.29);
                font-weight: bold;
                @media (max-width: 360px) {
                    font-size: @font + .3;
                    margin: 4px 2px;
                }
                &.lang_en_span {
                    width: 80%;
                    letter-spacing: 0;
                    font-size: 1rem;
                    line-height: 20px;
                }

            }
        }
        .reservation_item_left {
            margin: 4px 0 0 4%;
            width: 64%;
            display: flex;
            flex-wrap: wrap;
            li {
                height: 47px;
                line-height: 47px;
                margin-bottom: 10px;
                width: 47%;
                margin-right: 6%;
                text-align: center;
                .border-radius(5px);
                .box-shadow;
                overflow: hidden;
                text-shadow: 0.2px 0.1px 1px rgba(0, 0, 0, 0.29);
                @media (max-width: 360px) {
                    height: 38px;
                    line-height: 38px;
                    a {
                        font-size: .9rem;

                    }
                }
                &:nth-child(2n) {
                    margin-right: 0;
                }
            }
        }
        &.ticket {
            & > a {
                background: url(../assets/images/index/ticket_1.png) no-repeat -5px -2px;
                background-size: 118px auto;
                @media (max-width: 360px) {
                    background-size: 110px auto;
                }
                @media (max-width: 320px) {
                    background: url(../assets/images/index/ticket_1.png) no-repeat -5px -2px;
                    background-size: 100px auto;
                }

            }

            .reservation_item_left {
                li {
                    background: url("../assets/images/index/ticket_2.png") no-repeat 0 0;
                    background-size: 110px auto;
                    color: #ff943a;
                    @media (max-width: 320px) {
                        background: url(../assets/images/index/ticket_2.png) no-repeat 0 0;
                        background-size: 100px auto;
                    }
                }
            }
        }
        &.card {
            & > a {
                background: url(../assets/images/index/card_1.png) no-repeat -5px -2px;
                background-size: 118px auto;
                @media (max-width: 360px) {
                    background-size: 110px auto;
                }
                @media (max-width: 320px) {
                    background: url(../assets/images/index/card_1.png) no-repeat -5px -2px;
                    background-size: 100px auto;
                }
            }
            .reservation_item_left {
                li {
                    background: url("../assets/images/index/card_2.png") no-repeat 0 0;
                    background-size: 110px auto;
                    color: #0bc063;
                    @media (max-width: 320px) {
                        background: url(../assets/images/index/card_2.png) no-repeat 0 0;
                        background-size: 100px auto;
                    }
                }
            }
        }
        &.restaurant {
            & > a {
                background: url(../assets/images/index/repast_1.png) no-repeat -5px -2px;
                background-size: 118px auto;

                @media (max-width: 360px) {
                    background-size: 110px auto;
                }
                @media (max-width: 320px) {
                    background: url(../assets/images/index/repast_1.png) no-repeat -5px -2px;
                    background-size: 100px auto;
                }
            }

            .reservation_item_left {
                li {
                    background: url("../assets/images/index/repast_2.png") no-repeat 0 0;
                    background-size: 110px auto;
                    color: #ff943a;
                    @media (max-width: 320px) {
                        background: url(../assets/images/index/repast_2.png) no-repeat 0 0;
                        background-size: 100px auto;
                    }
                }
            }
        }
        &.hotel {
            & > a {
                background: url(../assets/images/index/hotel_1.png) no-repeat -5px -2px;
                background-size: 118px auto;
                @media (max-width: 360px) {
                    background-size: 110px auto;
                }
                @media (max-width: 320px) {
                    background: url(../assets/images/index/hotel_1.png) no-repeat -5px -2px;
                    background-size: 100px auto;
                }
            }
            .reservation_item_left {
                li {
                    background: url("../assets/images/index/hotel_2.png") no-repeat 0 0;
                    background-size: 110px auto;
                    color: #ac6aa7;
                    @media (max-width: 320px) {
                        background: url(../assets/images/index/hotel_2.png) no-repeat 0 0;
                        background-size: 100px auto;
                    }
                }
            }
        }
    }

    @keyframes van-notice-bar-play {
        to {
            transform: translate3d(-100%, 0, 0);
        }
    }

    @keyframes van-notice-bar-play-infinite {
        to {
            transform: translate3d(-100%, 0, 0);
        }
    }

    @media (min-width: 768px)  and (orientation: portrait) {
        .home {
            .scroll {
                height: 320px;
                .slide-item {
                    width: 150px;
                    height: 198px;
                    margin-right: 20px;
                }
            }
            .slide-box {
                height: 249px;
            }
            .scroll h2, .activity h2 {
                line-height: 54px;
                font-size: 1.4rem;
            }
            .content {
                width: 90%;
                margin: 10px auto 0;
                .title {
                    height: 94px;
                    p {
                        font-size: 1.5rem;
                        line-height: 89px;
                    }
                }
            }
            .server_icons {
                height: 120px;
                li {
                    height: 120px;;
                    font-size: @font + .4;
                    i {
                        height: 80px;
                        &.icons1 {
                            background: url(../assets/images/index/index_1.png) no-repeat  30px -2px;;
                            background-size: 84px auto;
                        }
                        &.icons2 {
                            background: url(../assets/images/index/index_2.png) no-repeat 30px -2px;
                            background-size: 84px auto;
                        }
                        &.icons3 {
                            background: url(../assets/images/index/index_3.png) no-repeat 30px -2px;
                            background-size: 84px auto;
                        }
                        &.icons4 {
                            background: url(../assets/images/index/index_4.png) no-repeat 30px -2px;
                            background-size: 84px auto;
                        }
                    }
                    span {
                        line-height: 24px;
                    }

                }

            }
            .activity {

                .activity_box {
                    display: block;
                    width: 38%;
                    height: 206px;
                    margin: 5px 15px 0 4px;
                    &:last-child {
                        padding-right: 10px;
                    }
                }
                .activity_scroll {
                    height: 206px;
                }
                .activity_scroll_item {
                    width: 100%;
                    height: 192px;
                    margin: 5px 22px 0 4px;
                    .activity_img {
                        height: 78%;
                    }
                    h4 {
                        font-size: 1.2rem;
                        width: 92%;
                        line-height: 44px;
                    }

                }
                h2 {
                    position: relative;
                    span {
                        position: absolute;
                        top: 0;
                        right: 0;
                        display: block;
                        width: 30px;
                        height: 30px;
                        background: url(../assets/images/personalCenter/direction.png) no-repeat 15px 12px;
                        background-size: 8px auto;

                    }
                }

            }
        }

        .content_img {
            width: @width;

            img {
                width: @width;
            }
        }

        .reservation > li {
            margin-top: 10px;
            width: 100%;
            height: 194px;
            & > a {
                span {
                    font-size: 2.4rem;
                    width: 57%;
                    line-height: 47px;
                    margin: 16px 2px;
                }
            }
            .reservation_item_left {
                margin: 14px 0 0 4%;
                width: 64%;
                li {
                    height: 70px;
                    line-height: 70px;
                    font-size: 1.4rem;
                }
            }
            &.ticket {
                & > a {
                    background: url(../assets/images/index/ticket_1.png) no-repeat -5px -2px;
                    background-size: 209px auto;
                }
                .reservation_item_left {
                    li {
                        background: url("../assets/images/index/ticket_2.png") no-repeat 0 0;
                        background-size: 207px auto;
                    }
                }
            }
            &.card {
                & > a {
                    background: url(../assets/images/index/card_1.png) no-repeat -5px -2px;
                    background-size: 209px auto;

                }

                .reservation_item_left {
                    li {
                        background: url("../assets/images/index/card_2.png") no-repeat 0 0;
                        background-size: 207px auto;
                    }
                }
            }
            &.restaurant {
                & > a {
                    background: url(../assets/images/index/repast_1.png) no-repeat -5px -2px;
                    background-size: 209px auto;

                }

                .reservation_item_left {
                    li {
                        background: url("../assets/images/index/repast_2.png") no-repeat 0 0;
                        background-size: 207px auto;
                    }
                }
            }
            &.hotel {
                & > a {
                    background: url(../assets/images/index/hotel_1.png) no-repeat -5px -2px;
                    background-size: 209px auto;

                }

                .reservation_item_left {
                    li {
                        background: url("../assets/images/index/hotel_2.png") no-repeat 0 0;
                        background-size: 207px auto;
                    }
                }
            }
        }
    }

    @media (min-width: 1024px) {
        @vh: 13.66px ;
        .home {
            .slide-box {
                height: 328px;
            }
            .scroll {
                height: 410px;
                .slide-item {
                    width: 190px;
                    height: 266px;
                    margin-right: 28px;
                }
            }
            .scroll h2, .activity h2 {
                line-height: 64px;
                font-size: 2rem;
            }
            .content {
                width: 90%;
                margin: 10px auto 0;
                .title {
                    height: 10 * @vh;
                    p {
                        font-size: 2rem;
                        line-height: 9 * @vh;
                    }
                }
            }
            .server_icons {
                /*height: 14 * @vh;*/
                li {
                    /*height: 14 * @vh;*/
                    font-size: @font * 2;
                    i {
                        height: 9 * @vh;
                        &.icons1 {
                            background: url(../assets/images/index/index_1.png) no-repeat  30px -2px;;
                            background-size: 10 * @vh auto;
                        }
                        &.icons2 {
                            background: url(../assets/images/index/index_2.png) no-repeat 30px -2px;
                            background-size: 10 * @vh auto;
                        }
                        &.icons3 {
                            background: url(../assets/images/index/index_3.png) no-repeat 30px -2px;
                            background-size: 10 * @vh auto;
                        }
                        &.icons4 {
                            background: url(../assets/images/index/index_4.png) no-repeat 30px -2px;
                            background-size: 84px auto;
                        }
                    }
                    span {
                        line-height: 24px;
                    }

                }

            }
            .activity {

                .activity_box {
                    width: 52%;
                    height: 24 * @vh;
                    margin: 5px 32px 0 4px;
                    &:last-child {
                        padding-right: 10px;
                    }
                }
                .activity_scroll {
                    height: 24 * @vh;
                }
                .activity_scroll_item {
                    width: 100%;
                    height: 23 * @vh;
                    margin: 5px 22px 0 4px;
                    .activity_img {
                        height: 78%;
                    }
                    h4 {
                        font-size: 1.8rem;
                        line-height: 68px;
                    }

                }
                h2 {
                    position: relative;
                    span {
                        position: absolute;
                        top: 0;
                        right: 0;
                        display: block;
                        width: 30px;
                        height: 30px;
                        background: url(../assets/images/personalCenter/direction.png) no-repeat 15px 12px;
                        background-size: 8px auto;

                    }
                }

            }
        }

        .reservation > li {
            margin-top: 10px;
            width: 100%;
            height: 20 * @vh;
            & > a {
                span {
                    font-size: 6vw;
                    width: 58%;
                    line-height: 82px;
                    margin: 16px 2px;
                }
            }
            .reservation_item_left {
                margin: 14px 0 0 4%;
                width: 64%;
                li {
                    height: 8 * @vh;
                    line-height: 8 * @vh;
                    font-size: 2rem;
                }
            }
            &.ticket {
                & > a {
                    background: url(../assets/images/index/ticket_1.png) no-repeat -5px -2px;
                    background-size: 100% auto;
                }
                .reservation_item_left {
                    li {
                        background: url("../assets/images/index/ticket_2.png") no-repeat 0 0;
                        background-size: 100% auto;
                    }
                }
            }
            &.card {
                & > a {
                    background: url(../assets/images/index/card_1.png) no-repeat -5px -2px;
                    background-size: 100% auto;

                }

                .reservation_item_left {
                    li {
                        background: url("../assets/images/index/card_2.png") no-repeat 0 0;
                        background-size: 100% auto;
                    }
                }
            }
            &.restaurant {
                & > a {
                    background: url(../assets/images/index/repast_1.png) no-repeat -5px -2px;
                    background-size: 100% auto;

                }

                .reservation_item_left {
                    li {
                        background: url("../assets/images/index/repast_2.png") no-repeat 0 0;
                        background-size: 100% auto;
                    }
                }
            }
            &.hotel {
                & > a {
                    background: url(../assets/images/index/hotel_1.png) no-repeat -5px -2px;
                    background-size: 100% auto;

                }

                .reservation_item_left {
                    li {
                        background: url("../assets/images/index/hotel_2.png") no-repeat 0 0;
                        background-size: 100% auto;
                    }
                }
            }
        }
    }

    .bannerSwiper {
        width: 100%;
    }

    .bannerSwiper img {
        width: 100%;
    }

    .themeParkSwiper {
        width: 100%;
        height: 100%;
    }

    .themeParkSwiper img {
        /*width: 100%;*/
        height: 100%;
        border-radius: 10px;
    }

    /*巨屏代码样式*/
    .huge {
        position: fixed;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.3);
        top: 0;
        left: 0;
        z-index: 99999;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        padding: 44px 0;
        .huge_img {
            width: 274px;
            @media (max-width: 360px) {
                width: 240px;
            }
            img {
                width: 100%;
                -webkit-border-radius: 4px;
                -moz-border-radius: 4px;
                border-radius: 4px;
            }
        }
        .del_img {
            width: 100vw;
            height: 35px;
            margin-top: -227px;
            text-align: center;
            img {
                width: 35px;
            }
        }

    }

</style>
